import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__filter",
  "use": "general__filter-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"general__filter\">\n  <path d=\"M18.2595674,6.75 L18.9435085,7.45874056 L14.248961,14.3324103 L14.25,19.522967 L11.9006063,18.9523602 L11.7489313,15.2734835 L6.0735272,7.75948405 L6.58035808,6.84124192 L18.2595674,6.75 Z\" stroke=\"currentColor\" stroke-width=\"1.5\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol